import { useEffect, useRef } from 'react';
import { prefillVmLevelFields } from '../components/VMBasedMigrationsConfig/helpers';
import { IP_TYPE } from '../../../../constants/network';

export const useApplianceRedeployPrefill = ({
    isRedeploy,
    cloudAccount,
    subscriptions,
    form,
    loadSubscriptionDetails,
    prefillCommonFromAppliance,
    setStoragePaths,
    setLogicalNetworks,
    setInstanceTags,
}) => {
    const hasPrefilledRef = useRef(false);

    useEffect(() => {
        if (!hasPrefilledRef.current && isRedeploy && cloudAccount?.appliance && subscriptions?.length) {
            hasPrefilledRef.current = true;
            const appliance = cloudAccount.appliance;
            const cloud_properties = appliance.cloud_properties || {};

            if (cloud_properties.vapp_name) {
                form.setFieldsValue({ vmName: cloud_properties.vapp_name });
            }

            if (cloud_properties.tags && typeof cloud_properties.tags === 'object') {
                setInstanceTags(cloud_properties.tags);
            }

            prefillCommonFromAppliance(appliance);

            if (appliance.vm_level_migration_enabled) {
                prefillVmLevelFields(appliance, form);
            }

            if (cloud_properties.network) {
                const eth0 = cloud_properties.network.interfaces?.eth0 || {};
                const isStatic = eth0.ip_type === IP_TYPE.STATIC;
                form.setFieldsValue({
                    ipType: eth0.ip_type || IP_TYPE.DHCP,
                    ipAddr: isStatic ? eth0.ip_addr || '' : '',
                    netmask: isStatic ? eth0.netmask || '' : '',
                    gateway: isStatic ? cloud_properties.network.routes?.default_gateway || '' : '',
                    primaryDns: isStatic ? cloud_properties.network.dns?.primary || '' : '',
                    secondaryDns: isStatic ? cloud_properties.network.dns?.secondary || '' : '',
                });
            }

            if (cloud_properties.subscription_id) {
                loadRedeployData({
                    appliance,
                    form,
                    subscriptions,
                    loadSubscriptionDetails,
                    setStoragePaths,
                    setLogicalNetworks,
                });
            }
        }
    }, [isRedeploy, cloudAccount, subscriptions]);
};

const loadRedeployData = async ({
    appliance,
    form,
    subscriptions,
    loadSubscriptionDetails,
    setStoragePaths,
    setLogicalNetworks,
}) => {
    const cloud_properties = appliance.cloud_properties || {};
    const { subscription_id } = cloud_properties;
    const subscription = subscriptions.find((candidate) => candidate.id === subscription_id);
    if (subscription) {
        form.setFieldsValue({ subscription: subscription_id });
        const subscriptionData = await loadSubscriptionDetails(subscription_id);
        if (subscriptionData) {
            const selectedLocation = cloud_properties?.custom_location?.toLowerCase();
            const storagePaths = (subscriptionData.storage_paths || []).filter(
                (storagePath) => (storagePath.custom_location || '').toLowerCase()  === selectedLocation,
            );
            const logicalNetworks = (subscriptionData.logical_networks || []).filter(
                (logicalNetwork) => (logicalNetwork.location_id || '').toLowerCase() === selectedLocation,
            );

            setStoragePaths(storagePaths);
            setLogicalNetworks(logicalNetworks);

            form.setFieldsValue({ location: selectedLocation });
            if (cloud_properties.storage_path) {
                form.setFieldsValue({ storagePath: cloud_properties.storage_path });
            }
            if (cloud_properties.resource_group) {
                form.setFieldsValue({ resourceGroup: cloud_properties.resource_group });
            }

            const vnet = cloud_properties.virtual_network;
            if (vnet?.name && vnet?.resource_group) {
                const virtualNetwork = logicalNetworks.find(
                    (network) => network.name === vnet.name && network.resource_group === vnet.resource_group,
                );
                if (virtualNetwork) {
                    form.setFieldsValue({ virtualNetwork: `${vnet.name}|${vnet.resource_group}` });
                }
            }
        }
    }
};

